import { useEffect, useRef, useState } from "react";
import {
  Constants,
  MenuItems,
  pageRouteConstants,
} from "../../constants/constants";
import ProfileImage2 from "../../assets/images/profile2.svg";
import Button from "../common/cta/Button";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import HamburgerIcon from "../../assets/images/HamburgerIcon";
import ProfileImage from "../../assets/images/profile.svg";
import NotificationIconInHeader from "../../assets/images/NotificationIconInHeader";
import SearchIconInHeader from "../../assets/images/SearcgIconInHeader";
import { componentMap, sideMenuIndexData } from "../common/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { updateIndex } from "../../store/slices/sideMenuSlice";
import { AppDispatch, RootState } from "../../store/store";
import SideMenuMobile from "../common/SideMenuMobile";
import { resetKey } from "../../store/slices/staffListSlice";

export interface Role {
  name: string;
  department: string;
  group: string;
}

export interface RoleItem {
  role: Role;
  specializations: any[]; // Or a more specific type if you have one
}
const MobileResponsiveHeader = ({
  handleLogout,
  setLogout,
  isLogout,
}: {
  handleLogout: any;
  setLogout: any;
  isLogout: boolean;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(0);
  const sideMenuIndex = useSelector(
    (state: RootState) => state.sideMenuDetails.index
  );

  const menuRef = useRef<any>(null);
  const navigate = useNavigate();
  const storedBaseRoles = readFromLocalStorage("baseRoles");
  const storedBaseRolesParsed = JSON.parse(storedBaseRoles || "[]");

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeSlider = () => {
    setSliderOpen(false);
  };

  const openSlider = () => {
    setSliderOpen(true);
  };

  const handleClick = (index: number) => {
    switch (index) {
      case 0:
        navigate(pageRouteConstants.dashBoardRoute);
        break;
      case 1:
        navigate(pageRouteConstants.staffListRoute);
        break;
      case 5:
        navigate(pageRouteConstants.locationMaster);
        break;
      case 6:
        navigate(pageRouteConstants.helpRoute);
        break;
      default:
        navigate(pageRouteConstants.comingSoonRoute);
    }
    closeSlider();
  };
  

  useEffect(() => {
    let index = sideMenuIndex;
    
    if (sideMenuIndexData[window.location.hash] !== undefined) {
      index = sideMenuIndexData[window.location.hash];
    }
    
    setSelectedMenu(index);
    if (index !== selectedMenu) {
      handleClick(index);
    }
  }, [sideMenuIndex]);

  const handleChange = (index: number) => {
    dispatch(updateIndex(index));
    dispatch(resetKey());
    handleClick(index); 
  };

  useEffect(() => {
    if (menuRef?.current) {
      menuRef.current.style.width = sliderOpen ? "256px" : "81px";
    }
  }, [sliderOpen]);

  return (
    <>
      <div className="border-b-white shadow-lg">
        <div className="bg-primary text-white justify-center h-[20vh] w-full px-4 flex flex-col shadow-md">
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center gap-2">
              {!sliderOpen && (
                <button
                  data-testid="hamburger-icon"
                  onClick={() => setSliderOpen(true)}
                  className="focus:outline-none"
                >
                  <HamburgerIcon />
                </button>
              )}
              <img
                className="transition-all"
                height="12px"
                width="32px"
                alt="ProfileImg"
                src={ProfileImage}
              />
            </div>

            <div className="flex items-center gap-4">
              <NotificationIconInHeader />
              <SearchIconInHeader />
              <button
                data-testid="logout"
                onClick={() => setLogout(!isLogout)}
                className="flex cursor-pointer"
              >
                <img
                  height="40px"
                  width="40px"
                  alt="ProfileImg"
                  src={ProfileImage2}
                />
              </button>
            </div>
          </div>

          <div className="mt-2">
            <div className=" text font-poppins">
              {Constants.Welcome} {readFromLocalStorage("userName") ?? "Dealer"}
            </div>
            <div className="text-sm font-poppins">
              {storedBaseRolesParsed.map(
                (roleItem: RoleItem, index: number) => (
                  <div key={index}>{roleItem?.role?.name ?? "Dealer"}</div>
                )
              )}
            </div>
          </div>
        </div>

        {sliderOpen && (
          <div className="absolute top-0 left-0 w-full h-full z-50">
            <SideMenuMobile
              menuItems={MenuItems}
              selectedMenuIndex={selectedMenu}
              componentMap={componentMap}
              openModal={openModal}
              closeModal={closeModal}
              isSlideerOpen={sliderOpen}
              openSlider={openSlider}
              closeSlider={closeSlider}
              handleChange={handleChange}
              isModalOpen={isModalOpen}
              menuRef={menuRef}
            />
          </div>
        )}

        {isLogout && (
          <div className="z-10 fixed top-[90px] right-0 p-2 bg-white shadow-2xl w-[200px] h-[200px] rounded-lg">
            <Button
              handleClick={handleLogout}
              buttonText={"Logout"}
              className="focus:ring-4 focus:ring-gray-300 bg-primary ml-6 mt-5 text-white px-8 py-2 rounded-md transition duration-300 hover:bg-whiteColor hover:text-black hover:border-gray500 hover:border"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MobileResponsiveHeader;
